module.exports = __webpack_public_path__ + "img/xhp_map_paopao_arrow@2x.6245f305.png";